import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useScrollReset from '../../hooks/useScrollReset';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  // Disable browser scroll restoration on mount
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    // Also disable any CSS scroll behavior
    document.documentElement.style.scrollBehavior = 'auto';
    document.body.style.scrollBehavior = 'auto';
  }, []);

  // Use our aggressive scroll reset hook
  useScrollReset([pathname]);

  return null;
} 